<div class="layout">
  <nz-empty [nzNotFoundContent]="contentTpl"></nz-empty>
</div>
